<template>
  <div>
    <div v-if="!lastSearch">
      <p class="text-muted">{{ $t('Nenhuma busca concluída.') }}</p>
    </div>
    <div v-else>
      <div
        v-if="lastSearch.status === 'running'"
        class="progress mb-3">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          :style="{ width: `${lastSearch.progress.completion}%` }"
          :aria-valuenow="lastSearch.progress.completion"
          aria-valuemin="0"
          aria-valuemax="100"></div>
      </div>

      <table class="mb-3">
        <tr>
          <td class="pr-4"><b>Status:</b></td>
          <td>
            {{ lastSearch.statusName }}
            <span v-if="lastSearch.status === 'running'">
              -
              <a
                href="javascript:void(0)"
                @click="stopSearch">
                parar
              </a>
            </span>
          </td>
        </tr>
        <tr>
          <td class="pr-4"><b>Encontrados:</b></td>
          <td>{{ lastSearch.progress.found }} de {{ lastSearch.count }}</td>
        </tr>
        <tr>
          <td class="pr-4"><b>Início:</b></td>
          <td>{{ formatDate(lastSearch.created_at) }}</td>
        </tr>
        <tr v-if="lastSearch.auto_adjust_enabled">
          <td class="pr-2"><b>Auto ajuste:</b></td>
          <td>Ativado</td>
        </tr>
        <tr v-if="lastSearch.auto_adjust_enabled">
          <td class="pr-2"><b>Tentativa:</b></td>
          <td>{{ lastSearch.auto_adjust_attempts }}</td>
        </tr>
        <tr v-if="lastSearch.auto_adjust_enabled && lastSearch.auto_adjust_change_reason">
          <td class="pr-2"><b>Alterações:</b></td>
          <td>{{ lastSearch.auto_adjust_change_reason }}</td>
        </tr>
      </table>

      <p class="text-muted">
        Se os perfis encontrados forem abaixo do esperado ou não estiverem aderentes à vaga, <b>aprimore a busca</b>.
      </p>
      <button
        class="btn btn-outline-primary"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        @click="redefineCriteria"
        :disabled="lastSearch.status === 'running'">
        Aprimorar busca
      </button>

      <h5 class="mb-3 mt-4">Texto de pesquisa</h5>
      <p><i>{{ lastSearch.query }}</i></p>

      <h5 class="mb-3 mt-4">Critérios</h5>
      <ul class="list-group">
        <li
          v-for="(criteria, index) in lastSearch.criteria"
          :key="index"
          class="list-group-item"
          data-toggle="collapse"
          :data-target="`#collapse${index}`"
          aria-expanded="false"
          :aria-controls="`collapse${index}`"
          style="cursor: pointer; font-size: 0.9rem;">
          <div>
            <div><b>{{ `Critério ${index + 1}` }}</b></div>
            <div><b>{{ $n(criteria.success_rate, {style: 'decimal', minimumFractionDigits: 2}) }}%</b> dos perfis analisados passaram nesse critério.</div>
          </div>
          <div
            class="mt-3 text-muted collapse hide"
            :id="`collapse${index}`">
            <i>{{ criteria.description }}</i>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobSeekerSearchs',
  props: {
    searches: {
      type: Object,
      required: false
    }
  },
  computed: {
    lastSearch () {
      if (this.searches && this.searches.docs.length) {
        const item = this.searches.docs[0]
        return {
          ...item,
          statusName: {
            running: 'Em andamento',
            completed: 'Concluída',
            canceled: 'Cancelada'
          }[item.status] || item.status
        }
      }
      return null
    }
  },
  methods: {
    formatDate (date) {
      return new Date(date).toLocaleString('pt-BR')
    },
    stopSearch () {
      this.$emit('stopSearch', this.lastSearch._id)
    },
    redefineCriteria () {
      this.$emit('redefineCriteria', {
        type: 'from_search',
        searchId: this.lastSearch._id
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Job/JobSeeker/JobSeekerSearchs.vue